import { DIRECT_UPLOAD_ACTIONS } from './directUpload.types';
export const setUploadAction = (key, payload) => ({
    type: DIRECT_UPLOAD_ACTIONS.SET_UPLOAD,
    key,
    payload
});
export const setProgressAction = (key, progress) => ({
    type: DIRECT_UPLOAD_ACTIONS.SET_PROGRESS,
    key,
    progress
});
export const setErrorAction = (key, error) => ({
    type: DIRECT_UPLOAD_ACTIONS.SET_ERROR,
    key,
    error
});
export const removeUploadAction = (key) => ({
    type: DIRECT_UPLOAD_ACTIONS.REMOVE_UPLOAD,
    key
});
export const clearAllUploadsAction = () => ({
    type: DIRECT_UPLOAD_ACTIONS.CLEAR_ALL
});
